import { Box, FormHelperText } from '@mui/material';
import { useField } from 'formik';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { cx } from '../../../helpers/global';
import './phoneField.css';

interface Props {
  name: string;
  autoFocus?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export default function ContactPhoneField({
  name,
  autoFocus,
  placeholder,
  disabled,
}: Props) {
  const [, { value, error, touched }, { setValue, setTouched }] =
    useField<string>(name);
  const isError = touched && !!error;

  return (
    <Box sx={{ width: '100%' }}>
      <div className={cx('guest-receipt-phone-input', isError && 'error')}>
        <ReactPhoneInput
          country="us"
          value={value || ''}
          onChange={next => setValue(next.replace(/\D/g, ''))}
          onBlur={() => setTouched(true)}
          inputProps={{
            name,
            autoFocus,
            autoComplete: 'tel',
          }}
          placeholder={placeholder}
          countryCodeEditable={false}
          specialLabel=""
          disabled={disabled}
          disableDropdown={disabled}
        />
      </div>
      {isError && (
        <FormHelperText
          error
          sx={{
            marginTop: '4px',
            marginLeft: '4px',
            fontSize: 'caption.fontSize',
            lineHeight: 1.2,
          }}>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
}
